import { useEffect } from 'react';

/** Заголовок вкладки браузера (прототип: «GWine Admin»). */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (title) document.title = title;
  }, [title]);
}
